module.exports = {
  "zones": {
    "Africa/Mogadishu": ["z", {
      "wallclock": -315619200000,
      "format": "EAT",
      "abbrev": "EAT",
      "offset": 10800000,
      "posix": -315629100000,
      "save": 0
    }, {
      "wallclock": -946771200000,
      "format": "+0245",
      "abbrev": "+0245",
      "offset": 9900000,
      "posix": -946780200000,
      "save": 0
    }, {
      "wallclock": -1262304000000,
      "format": "+0230",
      "abbrev": "+0230",
      "offset": 9000000,
      "posix": -1262314800000,
      "save": 0
    }, {
      "wallclock": -1309737600000,
      "format": "EAT",
      "abbrev": "EAT",
      "offset": 10800000,
      "posix": -1309746436000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 8836000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};